import React from "react";
import { CalendarIcon, ChartLineUpIcon } from "@phosphor-icons/react";
import CustomTable from "../../../shared/CustomTable/CustomTable";
import EmptyContainer from "../../../shared/EmptyContainer/EmptyContainer";
import { IExerciseHistoryTraining } from "../../../endpoints/profiling";
import styles from "../AthleteExerciseHistoryPage.module.scss";

interface TrainingHistoryTabProps {
  trainings: IExerciseHistoryTraining[];
  isLoading: boolean;
}

function formatDate(d?: string): string {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("it-IT", {
      day: "2-digit",
      month: "2-digit",
      year: "2-digit",
    });
  } catch {
    return d;
  }
}

const TRAINING_HEADERS = ["Data", "Scheda", "Set", "Carico massimo", "RPE", "Durata"] as const;

const TrainingHistoryTab: React.FC<TrainingHistoryTabProps> = ({
  trainings,
  isLoading,
}) => {
  if (!isLoading && trainings.length === 0) {
    return (
      <EmptyContainer
        Icon={ChartLineUpIcon}
        title="Nessun allenamento registrato"
        description="Le sessioni di allenamento appariranno qui quando verranno loggate."
        addButton={false}
        onClick={() => undefined}
        buttonText=""
      />
    );
  }

  const tableData = trainings.map((t) => {
    const maxLoad = t.sets.reduce((max, s) => {
      const load = s.loadActual ?? 0;
      return load > max ? load : max;
    }, 0);
    const maxLoadUnit = t.sets.find((s) => s.loadActual != null)?.loadActualUnit ?? "kg";
    return {
      _id: t.workoutLogId,
      date: formatDate(t.date),
      workoutName: t.workoutName || "Sessione",
      sets: `${t.sets.length} set`,
      maxLoad: maxLoad > 0 ? `${maxLoad} ${maxLoadUnit}` : "—",
      rpe: t.rpe != null ? String(t.rpe) : "—",
      duration: t.duration != null ? `${t.duration} min` : "—",
    };
  });

  return (
    <div className={styles.tabPanel}>
      <CustomTable
        isLoading={isLoading}
        headers={[...TRAINING_HEADERS]}
        data={tableData}
        fields={{
          Data: {
            key: "date",
            customComponent: (value) => (
              <span style={{ display: "inline-flex", alignItems: "center", gap: 4 }}>
                <CalendarIcon size={12} color="#b5b5b5" />
                {value}
              </span>
            ),
          },
          Scheda: { key: "workoutName" },
          Set: { key: "sets" },
          "Carico massimo": { key: "maxLoad" },
          RPE: { key: "rpe" },
          Durata: { key: "duration" },
        }}
      />
    </div>
  );
};

export default TrainingHistoryTab;
